/** 优化目标-表单配置 */
export {
  optimize_goal,
};

/**
 * 优化目标
 * @description inventory_catalog = MANUAL && inventory_type 仅有 INVENTORY_UNION_SLOT 时 有效且必填
 */
const optimize_goal = {
  value: {},
  children: {
    track_type: {
      label: '数据对接方式',
      type: 'radio-group',
      isButton: true,
      is_filter: true,
      options: [
        {
          label: '事件管理',
          value: 2,
        },
      ],
      value: 2,
    },
    // 事件管理资产 id，list长度上限为 1
    asset_ids: {
      label: '事件资产',
      type: 'select',
      options: [],
      value: [],
      props: {
        multiple: true,
        multipleLimit: 1,
        disabled: true,
      },
      hidden: false,
    },
    external_action: {
      label: '优化目标',
      type: 'select',
      props: {
        disabled: false,
      },
      options: [],
      value: '',
      rules: [{ required: true, message: '请选择优化目标', trigger: 'change' }],
      is_loading: false,
    },
    deep_external_action: {
      label: '深度优化目标',
      type: 'select',
      props: {
        disabled: false,
      },
      hidden: true,
      options: [],
      value: '',
    },
  },
};
